/**
 * 物流渠道编辑页面
 */

import React from 'react';
import { SaveOutlined } from '@ant-design/icons';
import { PageHeader } from '../../components/Layout/PageHeader';
import { useShippingChannel } from './components/ChannelEdit/useShippingChannel';
import { ChannelForm } from './components/ChannelEdit/ChannelForm';
import { RateTierTable } from './components/ChannelEdit/RateTierTable';
import { RateTierModal } from './components/ChannelEdit/RateTierModal';

export const ShippingChannelEdit: React.FC = () => {
    const {
        form,
        loading,
        rateTiers,
        editingTier,
        tierModalVisible,
        setTierModalVisible,
        tierForm,
        isEditing,
        handleSubmit,
        handleAddTier,
        handleEditTier,
        handleSaveTier,
        handleDeleteTier,
        navigate,
    } = useShippingChannel();

    return (
        <div className="sku-management-page">
            <PageHeader
                title={isEditing ? '编辑物流渠道' : '新建物流渠道'}
                subtitle="配置物流渠道信息和运费阶梯"
                onBack={() => navigate('/shipping-management')}
                actions={[
                    {
                        key: 'save',
                        label: '保存',
                        type: 'primary',
                        icon: <SaveOutlined />,
                        onClick: handleSubmit,
                        loading,
                    },
                ]}
            />

            <div className="sku-management-content">
                <ChannelForm form={form} />

                {isEditing && (
                    <RateTierTable
                        rateTiers={rateTiers}
                        onAdd={handleAddTier}
                        onEdit={handleEditTier}
                        onDelete={handleDeleteTier}
                    />
                )}
            </div>

            <RateTierModal
                visible={tierModalVisible}
                editingTier={editingTier}
                form={tierForm}
                onOk={handleSaveTier}
                onCancel={() => setTierModalVisible(false)}
            />
        </div>
    );
};

export default ShippingChannelEdit;
